export default "__VITE_ASSET__DgkT6zhB__"